/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
import * as import0 from '@angular/core/src/linker/ng_module_factory';
import * as import1 from '../../app/app.module';
import * as import2 from '@angular/common/src/common_module';
import * as import3 from '@angular/core/src/application_module';
import * as import4 from '@angular/platform-browser/src/browser';
import * as import5 from '@angular/forms/src/directives';
import * as import6 from '@angular/forms/src/form_providers';
import * as import7 from '@angular/router/src/router_module';
import * as import8 from '@angular/common/src/localization';
import * as import9 from '@angular/core/src/application_init';
import * as import10 from '@angular/core/src/testability/testability';
import * as import11 from '@angular/core/src/application_ref';
import * as import12 from '@angular/core/src/linker/compiler';
import * as import13 from '@angular/platform-browser/src/dom/events/hammer_gestures';
import * as import14 from '@angular/platform-browser/src/dom/events/event_manager';
import * as import15 from '@angular/platform-browser/src/dom/shared_styles_host';
import * as import16 from '@angular/platform-browser/src/dom/dom_renderer';
import * as import17 from '@angular/platform-browser/src/security/dom_sanitization_service';
import * as import18 from '@angular/core/src/animation/animation_queue';
import * as import19 from '@angular/core/src/linker/view_utils';
import * as import20 from '@angular/platform-browser/src/browser/title';
import * as import21 from '@angular/forms/src/directives/radio_control_value_accessor';
import * as import22 from '@angular/common/src/location/location';
import * as import23 from '@angular/router/src/url_tree';
import * as import24 from '@angular/router/src/router_outlet_map';
import * as import25 from '@angular/core/src/linker/system_js_ng_module_factory_loader';
import * as import26 from '@angular/router/src/router_preloader';
import * as import27 from '../../app/app_bus/app-bus';
import * as import29 from './tone_list/tone-list.component.ngfactory';
import * as import30 from './app.component.ngfactory';
import * as import31 from '@angular/core/src/application_tokens';
import * as import32 from '@angular/platform-browser/src/dom/events/dom_events';
import * as import33 from '@angular/platform-browser/src/dom/events/key_events';
import * as import34 from '@angular/core/src/zone/ng_zone';
import * as import35 from '@angular/platform-browser/src/dom/debug/ng_probe';
import * as import36 from '@angular/common/src/location/platform_location';
import * as import37 from '@angular/common/src/location/location_strategy';
import * as import38 from '../../app/tone_list/tone-list.component';
import * as import39 from '@angular/router/src/url_handling_strategy';
import * as import40 from '@angular/router/src/route_reuse_strategy';
import * as import41 from '@angular/router/src/router';
import * as import42 from '@angular/core/src/console';
import * as import43 from '@angular/core/src/i18n/tokens';
import * as import44 from '@angular/core/src/error_handler';
import * as import45 from '@angular/platform-browser/src/dom/dom_tokens';
import * as import46 from '@angular/platform-browser/src/dom/animation_driver';
import * as import47 from '@angular/core/src/render/api';
import * as import48 from '@angular/core/src/security';
import * as import49 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import50 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import51 from '@angular/core/src/linker/ng_module_factory_loader';
import * as import52 from '@angular/router/src/router_config_loader';
import * as import53 from '@angular/router/src/router_state';
class AppModuleInjector extends import0.NgModuleInjector {
    constructor(parent) {
        super(parent, [
            import29.ToneListComponentNgFactory,
            import30.AppComponentNgFactory
        ], [import30.AppComponentNgFactory]);
    }
    get _LOCALE_ID_8() {
        if ((this.__LOCALE_ID_8 == null)) {
            (this.__LOCALE_ID_8 = 'en-US');
        }
        return this.__LOCALE_ID_8;
    }
    get _NgLocalization_9() {
        if ((this.__NgLocalization_9 == null)) {
            (this.__NgLocalization_9 = new import8.NgLocaleLocalization(this._LOCALE_ID_8));
        }
        return this.__NgLocalization_9;
    }
    get _ApplicationRef_14() {
        if ((this.__ApplicationRef_14 == null)) {
            (this.__ApplicationRef_14 = this._ApplicationRef__13);
        }
        return this.__ApplicationRef_14;
    }
    get _Compiler_15() {
        if ((this.__Compiler_15 == null)) {
            (this.__Compiler_15 = new import12.Compiler());
        }
        return this.__Compiler_15;
    }
    get _APP_ID_16() {
        if ((this.__APP_ID_16 == null)) {
            (this.__APP_ID_16 = import31._appIdRandomProviderFactory());
        }
        return this.__APP_ID_16;
    }
    get _DOCUMENT_17() {
        if ((this.__DOCUMENT_17 == null)) {
            (this.__DOCUMENT_17 = import4._document());
        }
        return this.__DOCUMENT_17;
    }
    get _HAMMER_GESTURE_CONFIG_18() {
        if ((this.__HAMMER_GESTURE_CONFIG_18 == null)) {
            (this.__HAMMER_GESTURE_CONFIG_18 = new import13.HammerGestureConfig());
        }
        return this.__HAMMER_GESTURE_CONFIG_18;
    }
    get _EVENT_MANAGER_PLUGINS_19() {
        if ((this.__EVENT_MANAGER_PLUGINS_19 == null)) {
            (this.__EVENT_MANAGER_PLUGINS_19 = [
                new import32.DomEventsPlugin(),
                new import33.KeyEventsPlugin(),
                new import13.HammerGesturesPlugin(this._HAMMER_GESTURE_CONFIG_18)
            ]);
        }
        return this.__EVENT_MANAGER_PLUGINS_19;
    }
    get _EventManager_20() {
        if ((this.__EventManager_20 == null)) {
            (this.__EventManager_20 = new import14.EventManager(this._EVENT_MANAGER_PLUGINS_19, this.parent.get(import34.NgZone)));
        }
        return this.__EventManager_20;
    }
    get _DomSharedStylesHost_21() {
        if ((this.__DomSharedStylesHost_21 == null)) {
            (this.__DomSharedStylesHost_21 = new import15.DomSharedStylesHost(this._DOCUMENT_17));
        }
        return this.__DomSharedStylesHost_21;
    }
    get _AnimationDriver_22() {
        if ((this.__AnimationDriver_22 == null)) {
            (this.__AnimationDriver_22 = import4._resolveDefaultAnimationDriver());
        }
        return this.__AnimationDriver_22;
    }
    get _DomRootRenderer_23() {
        if ((this.__DomRootRenderer_23 == null)) {
            (this.__DomRootRenderer_23 = new import16.DomRootRenderer_(this._DOCUMENT_17, this._EventManager_20, this._DomSharedStylesHost_21, this._AnimationDriver_22, this._APP_ID_16));
        }
        return this.__DomRootRenderer_23;
    }
    get _NgProbeToken_24() {
        if ((this.__NgProbeToken_24 == null)) {
            (this.__NgProbeToken_24 = [import7.routerNgProbeToken()]);
        }
        return this.__NgProbeToken_24;
    }
    get _RootRenderer_25() {
        if ((this.__RootRenderer_25 == null)) {
            (this.__RootRenderer_25 = import35._createConditionalRootRenderer(this._DomRootRenderer_23, this.parent.get(import35.NgProbeToken, null), this._NgProbeToken_24));
        }
        return this.__RootRenderer_25;
    }
    get _DomSanitizer_26() {
        if ((this.__DomSanitizer_26 == null)) {
            (this.__DomSanitizer_26 = new import17.DomSanitizerImpl());
        }
        return this.__DomSanitizer_26;
    }
    get _Sanitizer_27() {
        if ((this.__Sanitizer_27 == null)) {
            (this.__Sanitizer_27 = this._DomSanitizer_26);
        }
        return this.__Sanitizer_27;
    }
    get _AnimationQueue_28() {
        if ((this.__AnimationQueue_28 == null)) {
            (this.__AnimationQueue_28 = new import18.AnimationQueue(this.parent.get(import34.NgZone)));
        }
        return this.__AnimationQueue_28;
    }
    get _ViewUtils_29() {
        if ((this.__ViewUtils_29 == null)) {
            (this.__ViewUtils_29 = new import19.ViewUtils(this._RootRenderer_25, this._Sanitizer_27, this._AnimationQueue_28));
        }
        return this.__ViewUtils_29;
    }
    get _IterableDiffers_30() {
        if ((this.__IterableDiffers_30 == null)) {
            (this.__IterableDiffers_30 = import3._iterableDiffersFactory());
        }
        return this.__IterableDiffers_30;
    }
    get _KeyValueDiffers_31() {
        if ((this.__KeyValueDiffers_31 == null)) {
            (this.__KeyValueDiffers_31 = import3._keyValueDiffersFactory());
        }
        return this.__KeyValueDiffers_31;
    }
    get _SharedStylesHost_32() {
        if ((this.__SharedStylesHost_32 == null)) {
            (this.__SharedStylesHost_32 = this._DomSharedStylesHost_21);
        }
        return this.__SharedStylesHost_32;
    }
    get _Title_33() {
        if ((this.__Title_33 == null)) {
            (this.__Title_33 = new import20.Title());
        }
        return this.__Title_33;
    }
    get _RadioControlRegistry_34() {
        if ((this.__RadioControlRegistry_34 == null)) {
            (this.__RadioControlRegistry_34 = new import21.RadioControlRegistry());
        }
        return this.__RadioControlRegistry_34;
    }
    get _ROUTER_CONFIGURATION_35() {
        if ((this.__ROUTER_CONFIGURATION_35 == null)) {
            (this.__ROUTER_CONFIGURATION_35 = {});
        }
        return this.__ROUTER_CONFIGURATION_35;
    }
    get _LocationStrategy_36() {
        if ((this.__LocationStrategy_36 == null)) {
            (this.__LocationStrategy_36 = import7.provideLocationStrategy(this.parent.get(import36.PlatformLocation), this.parent.get(import37.APP_BASE_HREF, null), this._ROUTER_CONFIGURATION_35));
        }
        return this.__LocationStrategy_36;
    }
    get _Location_37() {
        if ((this.__Location_37 == null)) {
            (this.__Location_37 = new import22.Location(this._LocationStrategy_36));
        }
        return this.__Location_37;
    }
    get _UrlSerializer_38() {
        if ((this.__UrlSerializer_38 == null)) {
            (this.__UrlSerializer_38 = new import23.DefaultUrlSerializer());
        }
        return this.__UrlSerializer_38;
    }
    get _RouterOutletMap_39() {
        if ((this.__RouterOutletMap_39 == null)) {
            (this.__RouterOutletMap_39 = new import24.RouterOutletMap());
        }
        return this.__RouterOutletMap_39;
    }
    get _NgModuleFactoryLoader_40() {
        if ((this.__NgModuleFactoryLoader_40 == null)) {
            (this.__NgModuleFactoryLoader_40 = new import25.SystemJsNgModuleLoader(this._Compiler_15, this.parent.get(import25.SystemJsNgModuleLoaderConfig, null)));
        }
        return this.__NgModuleFactoryLoader_40;
    }
    get _ROUTES_41() {
        if ((this.__ROUTES_41 == null)) {
            (this.__ROUTES_41 = [[{
                        path: '',
                        component: import38.ToneListComponent
                    }
                ]]);
        }
        return this.__ROUTES_41;
    }
    get _Router_42() {
        if ((this.__Router_42 == null)) {
            (this.__Router_42 = import7.setupRouter(this._ApplicationRef_14, this._UrlSerializer_38, this._RouterOutletMap_39, this._Location_37, this, this._NgModuleFactoryLoader_40, this._Compiler_15, this._ROUTES_41, this._ROUTER_CONFIGURATION_35, this.parent.get(import39.UrlHandlingStrategy, null), this.parent.get(import40.RouteReuseStrategy, null)));
        }
        return this.__Router_42;
    }
    get _ActivatedRoute_43() {
        if ((this.__ActivatedRoute_43 == null)) {
            (this.__ActivatedRoute_43 = import7.rootRoute(this._Router_42));
        }
        return this.__ActivatedRoute_43;
    }
    get _PreloadAllModules_47() {
        if ((this.__PreloadAllModules_47 == null)) {
            (this.__PreloadAllModules_47 = new import26.PreloadAllModules());
        }
        return this.__PreloadAllModules_47;
    }
    get _ROUTER_INITIALIZER_48() {
        if ((this.__ROUTER_INITIALIZER_48 == null)) {
            (this.__ROUTER_INITIALIZER_48 = import7.initialRouterNavigation(this._Router_42, this._ApplicationRef_14, this._RouterPreloader_46, this._ROUTER_CONFIGURATION_35));
        }
        return this.__ROUTER_INITIALIZER_48;
    }
    get _APP_BOOTSTRAP_LISTENER_49() {
        if ((this.__APP_BOOTSTRAP_LISTENER_49 == null)) {
            (this.__APP_BOOTSTRAP_LISTENER_49 = [this._ROUTER_INITIALIZER_48]);
        }
        return this.__APP_BOOTSTRAP_LISTENER_49;
    }
    get _AppBus_50() {
        if ((this.__AppBus_50 == null)) {
            (this.__AppBus_50 = new import27.AppBus());
        }
        return this.__AppBus_50;
    }
    createInternal() {
        this._CommonModule_0 = new import2.CommonModule();
        this._ApplicationModule_1 = new import3.ApplicationModule();
        this._BrowserModule_2 = new import4.BrowserModule(this.parent.get(import4.BrowserModule, null));
        this._InternalFormsSharedModule_3 = new import5.InternalFormsSharedModule();
        this._FormsModule_4 = new import6.FormsModule();
        this._ROUTER_FORROOT_GUARD_5 = import7.provideForRootGuard(this.parent.get(import41.Router, null));
        this._RouterModule_6 = new import7.RouterModule(this._ROUTER_FORROOT_GUARD_5);
        this._AppModule_7 = new import1.AppModule();
        this._ErrorHandler_10 = import4.errorHandler();
        this._ApplicationInitStatus_11 = new import9.ApplicationInitStatus(this.parent.get(import9.APP_INITIALIZER, null));
        this._Testability_12 = new import10.Testability(this.parent.get(import34.NgZone));
        this._ApplicationRef__13 = new import11.ApplicationRef_(this.parent.get(import34.NgZone), this.parent.get(import42.Console), this, this._ErrorHandler_10, this, this._ApplicationInitStatus_11, this.parent.get(import10.TestabilityRegistry, null), this._Testability_12);
        this._NoPreloading_44 = new import26.NoPreloading();
        this._PreloadingStrategy_45 = this._NoPreloading_44;
        this._RouterPreloader_46 = new import26.RouterPreloader(this._Router_42, this._NgModuleFactoryLoader_40, this._Compiler_15, this, this._PreloadingStrategy_45);
        return this._AppModule_7;
    }
    getInternal(token, notFoundResult) {
        if ((token === import2.CommonModule)) {
            return this._CommonModule_0;
        }
        if ((token === import3.ApplicationModule)) {
            return this._ApplicationModule_1;
        }
        if ((token === import4.BrowserModule)) {
            return this._BrowserModule_2;
        }
        if ((token === import5.InternalFormsSharedModule)) {
            return this._InternalFormsSharedModule_3;
        }
        if ((token === import6.FormsModule)) {
            return this._FormsModule_4;
        }
        if ((token === import7.ROUTER_FORROOT_GUARD)) {
            return this._ROUTER_FORROOT_GUARD_5;
        }
        if ((token === import7.RouterModule)) {
            return this._RouterModule_6;
        }
        if ((token === import1.AppModule)) {
            return this._AppModule_7;
        }
        if ((token === import43.LOCALE_ID)) {
            return this._LOCALE_ID_8;
        }
        if ((token === import8.NgLocalization)) {
            return this._NgLocalization_9;
        }
        if ((token === import44.ErrorHandler)) {
            return this._ErrorHandler_10;
        }
        if ((token === import9.ApplicationInitStatus)) {
            return this._ApplicationInitStatus_11;
        }
        if ((token === import10.Testability)) {
            return this._Testability_12;
        }
        if ((token === import11.ApplicationRef_)) {
            return this._ApplicationRef__13;
        }
        if ((token === import11.ApplicationRef)) {
            return this._ApplicationRef_14;
        }
        if ((token === import12.Compiler)) {
            return this._Compiler_15;
        }
        if ((token === import31.APP_ID)) {
            return this._APP_ID_16;
        }
        if ((token === import45.DOCUMENT)) {
            return this._DOCUMENT_17;
        }
        if ((token === import13.HAMMER_GESTURE_CONFIG)) {
            return this._HAMMER_GESTURE_CONFIG_18;
        }
        if ((token === import14.EVENT_MANAGER_PLUGINS)) {
            return this._EVENT_MANAGER_PLUGINS_19;
        }
        if ((token === import14.EventManager)) {
            return this._EventManager_20;
        }
        if ((token === import15.DomSharedStylesHost)) {
            return this._DomSharedStylesHost_21;
        }
        if ((token === import46.AnimationDriver)) {
            return this._AnimationDriver_22;
        }
        if ((token === import16.DomRootRenderer)) {
            return this._DomRootRenderer_23;
        }
        if ((token === import11.NgProbeToken)) {
            return this._NgProbeToken_24;
        }
        if ((token === import47.RootRenderer)) {
            return this._RootRenderer_25;
        }
        if ((token === import17.DomSanitizer)) {
            return this._DomSanitizer_26;
        }
        if ((token === import48.Sanitizer)) {
            return this._Sanitizer_27;
        }
        if ((token === import18.AnimationQueue)) {
            return this._AnimationQueue_28;
        }
        if ((token === import19.ViewUtils)) {
            return this._ViewUtils_29;
        }
        if ((token === import49.IterableDiffers)) {
            return this._IterableDiffers_30;
        }
        if ((token === import50.KeyValueDiffers)) {
            return this._KeyValueDiffers_31;
        }
        if ((token === import15.SharedStylesHost)) {
            return this._SharedStylesHost_32;
        }
        if ((token === import20.Title)) {
            return this._Title_33;
        }
        if ((token === import21.RadioControlRegistry)) {
            return this._RadioControlRegistry_34;
        }
        if ((token === import7.ROUTER_CONFIGURATION)) {
            return this._ROUTER_CONFIGURATION_35;
        }
        if ((token === import37.LocationStrategy)) {
            return this._LocationStrategy_36;
        }
        if ((token === import22.Location)) {
            return this._Location_37;
        }
        if ((token === import23.UrlSerializer)) {
            return this._UrlSerializer_38;
        }
        if ((token === import24.RouterOutletMap)) {
            return this._RouterOutletMap_39;
        }
        if ((token === import51.NgModuleFactoryLoader)) {
            return this._NgModuleFactoryLoader_40;
        }
        if ((token === import52.ROUTES)) {
            return this._ROUTES_41;
        }
        if ((token === import41.Router)) {
            return this._Router_42;
        }
        if ((token === import53.ActivatedRoute)) {
            return this._ActivatedRoute_43;
        }
        if ((token === import26.NoPreloading)) {
            return this._NoPreloading_44;
        }
        if ((token === import26.PreloadingStrategy)) {
            return this._PreloadingStrategy_45;
        }
        if ((token === import26.RouterPreloader)) {
            return this._RouterPreloader_46;
        }
        if ((token === import26.PreloadAllModules)) {
            return this._PreloadAllModules_47;
        }
        if ((token === import7.ROUTER_INITIALIZER)) {
            return this._ROUTER_INITIALIZER_48;
        }
        if ((token === import31.APP_BOOTSTRAP_LISTENER)) {
            return this._APP_BOOTSTRAP_LISTENER_49;
        }
        if ((token === import27.AppBus)) {
            return this._AppBus_50;
        }
        return notFoundResult;
    }
    destroyInternal() {
        this._ApplicationRef__13.ngOnDestroy();
        this._RouterPreloader_46.ngOnDestroy();
    }
}
export const AppModuleNgFactory = new import0.NgModuleFactory(AppModuleInjector, import1.AppModule);
//# sourceMappingURL=app.module.ngfactory.js.map